import * as audioHooks from './hooks/audio';
import * as authHooks from './hooks/auth';
import * as botHooks from './hooks/bot';
import * as botProfileHooks from './hooks/botProfile';
import * as chatHooks from './hooks/chat';
import * as checkoutHooks from './hooks/checkout';
import * as commonHooks from './hooks/common';
import * as generatorHooks from './hooks/generator';
import * as gridHooks from './hooks/grid';
import * as navigationHooks from './hooks/navigation';
import * as nsfwHooks from './hooks/nsfw';
import * as onboardingHooks from './hooks/onboarding';
import * as reportHooks from './hooks/report';
import * as retentionHooks from './hooks/retention';
import * as sextingPackHooks from './hooks/sextingPack';
import * as subscriptionHooks from './hooks/subscription';
import * as videoHooks from './hooks/video';

export const annals = {
	audio: audioHooks,
	auth: authHooks,
	bot: botHooks,
	chat: chatHooks,
	checkout: checkoutHooks,
	common: commonHooks,
	generator: generatorHooks,
	grid: gridHooks,
	navigation: navigationHooks,
	nsfw: nsfwHooks,
	onboarding: onboardingHooks,
	report: reportHooks,
	sextingPack: sextingPackHooks,
	video: videoHooks,
	retention: retentionHooks,
	botProfile: botProfileHooks,
	subscription: subscriptionHooks,
};
